import { useEffect, useState } from "react";
import { getProducts } from "../../api/frontApi";
import ProductForm from "./ProductForm";

export const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showProductForm, setShowProductForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
      loadProducts();
  }, []);

   const loadProducts = async () => {
    try {
      const data = await getProducts();
      setProducts(data);
    } catch (e) {
      console.error("Erreur chargement produits", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p style={{ color: "#00ff00" }}>Chargement...</p>;

  function showEditProduct(product) {
    setSelectedProduct(product);
    setShowProductForm(true);
  }

  return (
    <div style={{ margin: "20px 0" }}>
      {showProductForm ? (
        <ProductForm
          initialProduct={selectedProduct}
          onClose={() => {
            setShowProductForm(false);
            setSelectedProduct(null);
          
          }}
          onSuccess={() => {
            setShowProductForm(false);
            setSelectedProduct(null);
            loadProducts(); // Ricarica la lista dopo modifica/creazione
          }}
        />
      ) : (
        <>
          <h3
            style={{ color: "#00ff00", fontFamily: "'Courier New', monospace" }}
          >
            Liste des Produits
          </h3>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid #00ff00",
              fontFamily: "'Courier New', monospace",
            }}
          >
            <thead>
              <tr style={{ borderBottom: "1px solid #00ff00" }}>
                <th
                  style={{
                    textAlign: "left",
                    color: "#00ff00",
                    padding: "8px",
                  }}
                >
                  ID
                </th>
                <th
                  style={{
                    textAlign: "left",
                    color: "#00ff00",
                    padding: "8px",
                  }}
                >
                  Nom
                </th>
                <th
                  style={{
                    textAlign: "left",
                    color: "#00ff00",
                    padding: "8px",
                  }}
                >
                  Catégorie
                </th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr
                  key={product.id}
                  onClick={() => showEditProduct(product)}
                  style={{
                    borderBottom: "1px solid #333",
                    cursor: "pointer",
                    ":hover": { backgroundColor: "#111" },
                  }}
                >
                  <td style={{ color: "#00ff00", padding: "8px" }}>
                    {product.id}
                  </td>
                  <td style={{ color: "#00ff00", padding: "8px" }}>
                    {product.name}
                  </td>
                  <td style={{ color: "#00ff00", padding: "8px" }}>
                    {product.category?.name || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};
